import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface VisitorsListV2TableHeadProps {
  showVisitSummary: boolean;
  showFloor: boolean;
}

export const VisitorsListV2TableHead: FC<VisitorsListV2TableHeadProps> = ({ showVisitSummary, showFloor }) => (
  <thead>
    <tr className="border-b border-gray-200">
      <th className="px-4 py-3.5 text-left text-sm font-medium text-gray-900">
        <FormattedMessage id="visitsListV2.table.columns.visitor" />
      </th>
      <th className="px-4 py-3.5 text-left text-sm font-medium text-gray-900">
        <FormattedMessage id="visitsListV2.table.columns.expected" />
      </th>
      {showVisitSummary && (
        <th className="px-4 py-3.5 text-left text-sm font-medium text-gray-900">
          <FormattedMessage id="visitsListV2.table.columns.visitSummary" />
        </th>
      )}
      <th className="px-4 py-3.5 text-left text-sm font-medium text-gray-900">
        <FormattedMessage id="visitsListV2.table.columns.host" />
      </th>
      {showFloor && (
        <th className="px-4 py-3.5 text-left text-sm font-medium text-gray-900">
          <FormattedMessage id="visitsListV2.table.columns.floor" />
        </th>
      )}
      <th className="px-4 py-3.5 text-left text-sm font-medium text-gray-900">
        <FormattedMessage id="visitsListV2.table.columns.status" />
      </th>
      <th className="px-4 py-3.5 text-right text-sm font-medium text-gray-900">
        <FormattedMessage id="visitsListV2.table.columns.actions" />
      </th>
    </tr>
  </thead>
);
